import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sidebar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_sidebar_item = _resolveComponent("sidebar-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Logo, { collapse: _ctx.isCollapse }, null, 8, ["collapse"]),
    _createVNode(_component_el_scrollbar, { "wrap-class": "scrollbar-wrapper" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          "default-active": _ctx.activeMenu,
          collapse: _ctx.isCollapse,
          "background-color": _ctx.variables.menuBg,
          "text-color": _ctx.variables.menuText,
          "unique-opened": false,
          "active-text-color": _ctx.variables.menuActiveText,
          "collapse-transition": false,
          mode: "vertical",
          class: "nest-menu"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permRoutes, (route) => {
              return (_openBlock(), _createBlock(_component_sidebar_item, {
                key: route.path,
                item: route,
                "base-path": route.path
              }, null, 8, ["item", "base-path"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active", "collapse", "background-color", "text-color", "active-text-color"])
      ]),
      _: 1
    })
  ]))
}